/* popup-menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["maxWidth", "minWidth"];
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

import MenuGroup from './menu-group';

/**
 * @deprecated refer to MenuGroup, explicitly set maxWidth and minWidth
 */
var PopupMenuGroup = function PopupMenuGroup(_ref) {
  var _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 800 : _ref$maxWidth,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? 320 : _ref$minWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    React.createElement(MenuGroup, _extends({
      maxWidth: maxWidth,
      minWidth: minWidth
    }, rest))
  );
};
export default PopupMenuGroup;